import React from "react";

import { css, cx } from "@emotion/css";
import { ApiErrorData } from "@steto-care/steto-query";

import { useAPIErrorMessageParser } from "@/hooks/useAPIErrorMessageParser.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { Typography } from "@/uiKit/atoms/Typography.tsx";

export type ShowApiErrorProps = {
  errorMapping: Record<string, string>;
  className?: string;
  error?: ApiErrorData;
};

export const ShowApiError: React.FC<ShowApiErrorProps> = ({ className, errorMapping, error }) => {
  const styles = useStyles(makeStyles);
  const errorMessage = useAPIErrorMessageParser()(error, errorMapping);

  return (
    <div className={cx(className, styles.container)}>
      {errorMessage ? (
        <Typography variant="body" className={styles.error}>
          {errorMessage}
        </Typography>
      ) : null}
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css`
    height: 2.5em;
  `,
  error: css`
    color: ${theme.palette.error.main};
  `,
});
